import React from "react";
import s from "./MessagingMeta.module.scss";
import { Skeleton } from "antd";
type PropType = {
  totalSends: number;
  openRate: string;
  clickThroughRate: string;
  bounceRate: string;
  loading: boolean;
};
function EmailMeta({
  bounceRate,
  clickThroughRate,
  openRate,
  loading,
  totalSends,
}: PropType) {
  if (loading) {
    return (
      <div className={s.wrapper}>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
      </div>
    );
  }
  return (
    <div className={s.wrapper}>
      <div className={s.statWrapper}>
        <h5 className={s.statTitle}>Total sends</h5>
        <p className={s.statNumber}>{totalSends.toLocaleString()}</p>
      </div>
      <div className={s.statWrapper}>
        <h5 className={s.statTitle}>Open rate</h5>
        <p className={s.statNumber}>{openRate}</p>
      </div>
      <div className={s.statWrapper}>
        <h5 className={s.statTitle}>Click-through rate</h5>
        <p className={s.statNumber}>{clickThroughRate}</p>
      </div>
      <div className={s.statWrapper}>
        <h5 className={s.statTitle}>Bounce rate</h5>
        <p className={s.statNumber}>{bounceRate}</p>
      </div>
    </div>
  );
}

export default EmailMeta;
